import React from 'react'
import { PropTypes } from 'prop-types'
import Button from 'components/formElements/Button'
import { DataTable } from 'primereact/datatable'
import TableHeader from 'components/tableHeader/TableHeader'
import Icons from 'assets/icons'
import { useEffect, useState } from 'react'
import { useRequest } from 'hooks/useRequest'
import { Column } from 'primereact/column'
import useEditor from 'hooks/useEditor'
import moment from 'moment'
import FileUploadEditor from 'components/fileUploadEdıtor/FıleUploadEdıtor'
import { useDispatch, useSelector } from 'react-redux'
import { openApprovalModal } from 'redux/features/general/generalSlice'
import useToast from 'hooks/useToast'
import { useParams } from 'react-router-dom'
import AddInvoiceModalContent from './AddInvoiceModalContent'
import { getAlertClass, getResponsible, isAdmin, responsibleRoles, sourceTypes } from 'utils/Constants'
import { currencyFormatter } from 'utils/CurrencyFormatter'
import { Dialog } from 'primereact/dialog'
import InvoiceApprovalModalContent from './InvoiceApprovalModalContent'
import { useFileReader } from 'hooks/useFileReader'
import { setEdittedRow } from 'redux/features/projectDetail/projectDetailSlice'
import { getPermission } from 'utils/Auth'
import Spinner from 'components/loader/Spinner'

const CrInvoicesModalContent = ({ modalOpen, setModalOpen }) => {
	const [getData, getDataLoading] = useRequest()
	const { projectId } = useParams()
	const [updateInvoiceRow] = useRequest()
	const [addInvoice, addInvoiceLoading] = useRequest()
	const { showToast } = useToast()
	const { projectDetail, general } = useSelector((state) => state)
	const { invoiceStatuses, edittedRow } = projectDetail
	const { approvalModal } = general
	const [invoices, setInvoices] = useState([])
	const [formData, setFormData] = useState({
		projectId: Number(projectId),
		sourceType: sourceTypes.CR,
		responsibleRole: null,
		sourceId: modalOpen.crId,
		percent: null,
		currency: modalOpen?.currency,
		amount: null,
		invoiceStatusId: 3,
		name: '',
		estimatedDate: null,
		actualDate: null,
		invoiceDate: null,
		invoiceNo: '',
		description:''
	})
	const [invoiceApprovalModal, setInvoiceApprovalModal] = useState({ open: false, text: '', setter: null, invoiceStatusId: null })
	const dispatch = useDispatch()
	const { textEditor, calendarEditor, selectEditor, rowEditorBody, currencyEditor, percentEditor, InvoiceSelectEditor, calendarShortDateEditor } = useEditor()
	const [filesData, setFilesData, convert] = useFileReader()
	const [isAddCr, setIsAddCr] = useState()
	const [isDeleteCr, setIsDeleteCr] = useState()
	const [isUpdateCr, setIsUpdateCr] = useState()

	useEffect(() => {
		const isEdittedRow = Object.keys(edittedRow).length == 0
		return () => {
			if (isEdittedRow) {
				dispatch(setEdittedRow({}))
			}
		}
	},[])
	
	useEffect(() => {

		setIsAddCr(getPermission('Cr.create'))
		setIsDeleteCr(getPermission('Cr.delete'))
		setIsUpdateCr(getPermission('Cr.update'))


		if (modalOpen.step == 1 && !approvalModal.open) {
			getData('/Invoices/GetInvoiceProjectByAndSourceId', {
				method: 'GET',
				params: { projectid: Number(projectId), sourceId: modalOpen.crId },
			}).then((res) => {
				if (res.data.ok) {
					const data = res.data.result
					setInvoices(data?.filter(dt => dt.sourceType == "Cr"))
				}
			})
		} else if (modalOpen.step == 2) {
			setFormData({
				projectId: Number(projectId),
				sourceType: 3,
				responsibleRole: null,
				sourceId: modalOpen.crId,
				percent: null,
				currency: modalOpen?.currency,
				amount: null,
				invoiceStatusId: 3,
				name: '',
				estimatedDate: null,
				invoiceDate:null,
				actualDate: null,
				invoiceNo: '',
				description:''
			})
			setFilesData([])
		}
	}, [modalOpen.step, approvalModal])
	const handleDeleteRow = (deleteData, deleteEndpoint, tableForDelete) => {
		dispatch(openApprovalModal({ open: true, content: 'Silmek istedğinize emin misiniz?', deleteData, deleteEndpoint, tableForDelete }))
	}
	const deleteButton = (deleteData, deleteEndpoint, tableForDelete) => {
		return (
			<Icons.deleteNotFill
				onClick={() => {
					handleDeleteRow(deleteData, deleteEndpoint, tableForDelete)
				}}
				size={20}
				className='text-danger cursor-pointer'
			/>
		)
	}
	const handleCloseApprovalModal = () => {
		setInvoiceApprovalModal({ open: false, text: '', setter: null, invoiceStatusId: null })
		setFormData(prev => ({ ...prev, invoiceStatusId: invoiceApprovalModal.invoiceStatusId }))
	}
	const handleApproved = () => {

		if (invoiceApprovalModal.invoiceStatusId == 1) {
			setFormData(prev => ({ ...prev, actualDate: moment().add(3, 'hours').toISOString(), invoiceStatusId: invoiceApprovalModal.invoiceStatusId }))
			handleCloseApprovalModal()
		}
		if (invoiceApprovalModal.invoiceStatusId == 2) {
			if (!formData.estimatedDate) {
				showToast('Kesilecek Ay/Yıl seçimini yapınız','error')
			}else {
				setFormData(prev => ({ ...prev, invoiceStatusId: invoiceApprovalModal.invoiceStatusId }))
				handleCloseApprovalModal()
			}
		}
		if (invoiceApprovalModal.invoiceStatusId == 7) {
			if (!formData.invoiceNo || !formData.description) {
				showToast('Fatura Numarası ve Açıklama giriniz','error')
			}else {
				setFormData(prev => ({ ...prev, invoiceStatusId: invoiceApprovalModal.invoiceStatusId }))
				handleCloseApprovalModal()
			}
		}
	}
	const onRowEditComplete = (e) => {
		let _products2 = [...invoices]
		let { index } = e
		_products2[index] = edittedRow
		updateInvoiceRow('/Invoices/UpdateInvoices', {
			method: 'PUT',
			data: {...edittedRow,amount:edittedRow?.amount?.toString(),sourceType:sourceTypes.CR},
		}).then((res) => {
			if (res.data.ok) {
				setInvoices(_products2)
				showToast('Güncelleme Başarılı', 'success')
			}
			dispatch(setEdittedRow({}))
		})
	}
	const handleChange = (value, name) => {
		if (name == 'files') {
			convert(value)
		} else if (name == 'percent' && modalOpen.budget) {
			const amountData = Number(modalOpen?.budget) / 100 * Number(value)
			setFormData((prev) => ({ ...prev, [name]: value, amount: amountData.toFixed(0) }))
		} else if (name == 'invoiceStatusId') {
			if (value == 1) {
				setInvoiceApprovalModal({ open: true, invoiceStatusId: value, text: 'Ödeme tarihini bugün olarak güncellemek ister misiniz?' })
			} else if (value == 2) {
				setInvoiceApprovalModal({ open: true, invoiceStatusId: value, text: 'Ödeme Onayı Belgesi' })
			} else if (value == 7) {
				setInvoiceApprovalModal({ open: true, invoiceStatusId: value, text: 'Fatura No ve Ödeme Onayı Belgesi' })
			} else {
				setFormData((prev) => ({ ...prev, [name]: value }))
			}
		} else {
			setFormData((prev) => ({ ...prev, [name]: value }))
		}
	}
	const removeFile = (file) => {
		setFilesData(prev => ([...prev.filter(f => f.fileName != file.fileName)]))
	}
	const handleSubmit = () => {
		if (!modalOpen.budget) {
			showToast('Fatura kalemi eklemek için lütfen bütçeyi giriniz.', 'error')
		} else if (!formData.name) {
			showToast('Proje Adımı Giriniz', 'error')
		}
		else if (!formData.responsibleRole) {
			showToast('Sorumlu Kişiyi Seçiniz', 'error')
		} else if (formData.invoiceStatusId == 2 && !formData.estimatedDate) {
			showToast('Kesilecek Ay/Yıl seçimini yapınız','error')
		} else {
			const formDatas = new FormData()
			formDatas.append("SourceType", sourceTypes.CR);
			formDatas.append("SourceId", formData.sourceId);
			formDatas.append("Name", formData.name);
			formDatas.append("ProjectId", formData.projectId);
			formDatas.append("ResponsibleRole", formData.responsibleRole);
			formDatas.append("Percent", formData.percent);
			formDatas.append("Currency", formData.currency);
			formDatas.append("Amount", formData.amount);
			formDatas.append("EstimatedDate", formData.estimatedDate);
			formDatas.append("ActualDate", formData.actualDate);
			formDatas.append("InvoiceDate", formData.invoiceDate);
			formDatas.append("InvoiceStatusId", formData.invoiceStatusId);
			formDatas.append("InvoiceNo", formData.invoiceNo);
			formDatas.append("Description", formData.description);
			filesData.forEach(f => {
				formDatas.append('File', f.file)
			})
			addInvoice('/Invoices/AddInvoices', {
				method: 'POST',
				data: formDatas,
			}).then((res) => {
				if (res.data.ok) {
					showToast('Yeni Fatura Adımı Eklendi', 'success')
					setModalOpen((prev) => ({ ...prev, step: 1, width: '70%' }))
				} else {
					showToast('Bir Sorun Oluştu', 'error')
				}
			})
		}

	}
	const isAttentionInvoice = () => {
		const sum = invoices.length > 0 && invoices.map((e) => Number(e.amount)).reduce((partialSum, a) => partialSum + a, 0);

		return sum != modalOpen.budget && invoices.length != 0
			? true : false
	}
	if (getDataLoading) {
		return <div className="card">
			<div className="row">
				<div className="col-md-12 text-center">
					<Spinner size={3} />
				</div>
			</div>
		</div>
	}
	return <>
		<Dialog draggable={false} visible={invoiceApprovalModal.open} onHide={handleCloseApprovalModal}>
			<InvoiceApprovalModalContent filesData={filesData} removeFile={removeFile} formData={formData} handleChange={handleChange} handleClose={handleCloseApprovalModal} approvalModal={invoiceApprovalModal} handleApproved={handleApproved} />
		</Dialog>
		{
			modalOpen.step == 1 ? (
				<div className='row-margin-x mt-1'>
					<div className='col-md-12'>
						<DataTable
							emptyMessage='Hiç Kayıt Bulunamadı'
							size="small"
							responsiveLayout="stack"
							editMode='row'
							onRowEditInit={e => dispatch(setEdittedRow(e.data))}
							dataKey='id'
							header={
								<TableHeader
									title='Faturalar'
									isAttention={isAttentionInvoice()}
									button={isAddCr &&
										<Button
											className='btn-primary'
											title='Yeni Fatura Adımı Ekle'
											icon={<Icons.plus />}
											handleClick={() => setModalOpen((prev) => ({ ...prev, step: 2, width: '40%' }))}
										/>
									}
								/>
							}
							onRowEditComplete={onRowEditComplete}
							value={invoices}
						>
							<Column
								className='text-semi-bold'
								headerClassName='text-bold bg-primary text-default'
								field='name'
								header='Proje Adımı'
								style={{ width: 'auto' }}
								sortable='true'
								editor={(options) =>
									textEditor(options)
								}
							/>
							<Column
								className='text-semi-bold'
								headerClassName='text-bold bg-primary text-default'
								field='responsibleRole'
								style={{ width: 'auto' }}
								header='Sorumlu Kişi'
								sortable='true'
								body={(rowData) => {
									return <span>{getResponsible(rowData.responsibleRole)}</span>
								}}
								editor={(options) =>
									selectEditor(
										{ ...options, disabled: !isAdmin },
										responsibleRoles
									)
								}
							/>
							<Column
								className='text-semi-bold'
								headerClassName='text-bold bg-primary text-default'
								field='percent'
								style={{ width: 'auto' }}
								header='Ödeme Yüzdesi'
								sortable='true'
								editor={(options) => percentEditor(options, modalOpen.budget)}
								body={(rowData) => <span>%{rowData.percent}</span>}
							/>
							<Column
								className='text-semi-bold'
								headerClassName='text-bold bg-primary text-default'
								field='estimatedDate'
								style={{ width: 'auto' }}
								header='Kesilecek Ay'
								sortable='true'
								body={(rowData) => {
									const expectedDate = rowData.estimatedDate && moment(rowData.estimatedDate).format('YYYY-MM-DD')
									const diff = expectedDate && moment(new Date(), 'YYYY-MM-DD').diff(expectedDate, 'month')
									return (
										<span className={diff > 0 && (rowData.invoiceStatusId != 1 && rowData.invoiceStatusId != 7) && 'text-danger'}>
											{' '}
											<span>{rowData.estimatedDate && moment(rowData.estimatedDate).format('ll')}</span> <span>{diff > 0 && (rowData.invoiceStatusId != 1 && rowData.invoiceStatusId != 7) && 'Süresi Geçti'}</span>
										</span>
									)
								}}
								editor={(options) => calendarShortDateEditor(options)}
							/>
							<Column
								className='text-semi-bold'
								headerClassName='text-bold bg-primary text-default'
								field='invoiceDate'
								style={{ width: 'auto' }}
								header='Fatura Tarihi'
								sortable='true'
								body={(rowData) => {
									const actualDate = rowData.invoiceDate && moment(rowData.invoiceDate).format('LL')
									return <span>{actualDate}</span>
								}}
								editor={(options) => calendarEditor(options)}
							/>
							<Column
								className='text-semi-bold'
								headerClassName='text-bold bg-primary text-default'
								field='amount'
								style={{ width: 'auto' }}
								body={(rowData) => {
									return (
										<span>
											{currencyFormatter(rowData.amount)} {rowData.currency}
										</span>
									)
								}}
								header='Tutar'
								sortable='true'
								editor={(options) => currencyEditor(options)}
							/>
							<Column
								className='text-semi-bold'
								field='invoicesDocuments'
								style={{ width: 'auto' }}
								header='Ödeme Onayı'
								headerClassName='text-bold bg-primary text-default'
								sortable='true'
								editor={(options) => (
									<FileUploadEditor
										addEndpoint='/Invoices/AddInvoiceDocuments'
										deleteEndpoint='/Invoices/DeleteInvoiceDocuments'
										idName='InvoiceId'
										options={options}
									/>
								)}
								body={(rowData) => (
									<ul className='list-style-none'>
										{rowData.invoicesDocuments &&
											rowData.invoicesDocuments.map((p, i) => (
												<li key={i}>
													<a
														download={p.fileName}
														href={`data:${p.documentType};base64,${p.data}`}
														className='text-primary text-underlined cursor-pointer mr-2'
													>
														{p?.fileName}
													</a>
												</li>
											))}
									</ul>
								)}
							/>
							<Column
								className='text-semi-bold'
								field='invoiceStatusId'
								header='Durum'
								style={{ width: 'auto' }}
								headerClassName='text-bold bg-primary text-default'
								sortable='true'
								body={(rowData) => {
									return (
										<span className={getAlertClass(rowData?.invoiceStatusId)}>
											{invoiceStatuses?.find((s) => s.value == rowData.invoiceStatusId)?.label}
										</span>
									)
								}}
								editor={(options) => InvoiceSelectEditor({ ...options }, invoiceStatuses?.filter(s => (!s.label.includes('Ödendi') && !s.label.includes('Kesildi'))))}
							/>
							{isUpdateCr && <Column headerClassName='text-bold bg-primary text-default' style={{ width: '2.5rem' }} rowEditor body={(row, d) => rowEditorBody(d)} />}
							<Column
								field='action'
								style={{ width: '2.5rem' }}
								headerClassName='text-bold bg-primary text-default'
								className='text-semi-bold pl-0'
								body={(rowData) => <span className='d-flex'>
									{isDeleteCr && deleteButton(rowData, '/Invoices/DeleteInvoices', 'cb')}</span>}
							/>
						</DataTable>
					</div>
				</div>
			) : (
				<AddInvoiceModalContent submitLoading={addInvoiceLoading} formData={formData} removeFile={removeFile} handleChange={handleChange} handleSubmit={handleSubmit} setModalOpen={setModalOpen} />
			)
		}
	</>
}
CrInvoicesModalContent.propTypes = {
	modalOpen: PropTypes.object,
	setModalOpen: PropTypes.func,
}
export default CrInvoicesModalContent